import 'react-alice-carousel/lib/alice-carousel.css'
import {
  Button,
  HStack,
  IconButton,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Image,
  Text,
  useDisclosure,
  VStack,
  Skeleton,
  Box,
  FormControl,
  FormLabel,
  Switch,
  Flex,
  useColorMode,
} from '@chakra-ui/react'
import React, { FC, useState } from 'react'
import { Logo } from '../../dApp/components/Logo'
import { Player as Lottie } from '@lottiefiles/react-lottie-player'
import { useStartAuthTx } from '../../common/auth/startAuthHook'
import { useWalletSignInModal } from '../../../components/wallet-ui/useWalletSignInModal'
import { IoDiamondOutline } from 'react-icons/io5'
import { AiOutlineShareAlt, AiOutlineClose } from 'react-icons/ai'

export const NormalRaffleEntry: FC<{
  className?: string
  container?: string
  showPopup?: boolean
  handleClosePopup: () => void
  gemsEarned?: number | null
  raffleId: string
  raffleName: string
  collectionTwitter?: string | null
  experiencePointsEarned?: number | null
}> = ({
  className,
  container,
  showPopup,
  raffleName,
  raffleId,
  collectionTwitter,
  handleClosePopup,
  gemsEarned,
  experiencePointsEarned,
}) => {
  const { colorMode } = useColorMode()
  const isDarkMode = colorMode === 'dark'
  const raffleUrl = encodeURIComponent(`https://monet.community/r/${raffleId}`)
  const shareText = encodeURIComponent(`I just earned ${gemsEarned} gem points on Monet for entering the ${raffleName} raffle!\n\nCheck it out.`)
  const twitterLink = `https://twitter.com/intent/tweet?text=${shareText}&url=${raffleUrl}${collectionTwitter ? `&related=${collectionTwitter}` : ''}&via=MonetSAC`
  const shareOnTwitter = () => {
    window.open(twitterLink, '_blank')
  }

  return (
    <>
      <Modal isOpen={showPopup || false} onClose={handleClosePopup}>
        <ModalOverlay />
        <ModalContent
          background={isDarkMode ? '#1f2023' : '#fcfcfc'}
          maxWidth={['96%', '96%', '30rem']}
          borderRadius={30}
        >
          <ModalHeader alignContent={'flex-start'} textAlign='start'>
            <Button onClick={handleClosePopup}>
              <AiOutlineClose color={isDarkMode ? 'white' : 'black'} />
            </Button>
          </ModalHeader>
          <ModalBody textAlign='center'>
            <Image src='/images/rewards/normalRaffleEntry.svg' />
            <VStack gap='1.4rem' pt={'6'}>
              <Text fontSize={32} fontWeight={'bold'}>
                Woohoo! 🏆
              </Text>
              <Text color={'#7B7B7B'}>
                you just earned{' '}
                <span>
                  {experiencePointsEarned ?? 0} Points & {gemsEarned ?? 0} Gems
                </span>
                <br /> for entering the {raffleName} raffle. Keep it UP!
              </Text>
              <HStack gap={'4'}>
                <Button
                  variant={isDarkMode ? 'primaryDark' : 'primary'}
                  width={'220px'}
                  onClick={shareOnTwitter}
                >
                  <AiOutlineShareAlt style={{ marginRight: '6' }} size={20} />
                  Share
                </Button>
              </HStack>
            </VStack>
          </ModalBody>
          <ModalFooter />
        </ModalContent>
      </Modal>
    </>
  )
}
